import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { api, apiError, money } from "../../lib/api";
import { ImageField, Panel, TextField } from "./fields";

export const ExtrasPanel = ({ hotelId, values, onChange, owner = {} }) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin-extras", hotelId],
    queryFn: () => api.get(`/admin/hotels/${hotelId}/extras`).then((r) => r.data),
  });
  const set = (id, p) => onChange({ ...values, [id]: { name: "", description: "", image: "", ...values[id], ...p } });
  return (
    <Panel title="Extras (services)" hint="Extras come from eRes. Add a photo and a short description so guests see more than a name and price.">
      {isLoading && <Loader2 className="h-5 w-5 animate-spin text-brand" />}
      {error && <p className="text-sm text-red-600" data-testid="extras-error">{apiError(error)}</p>}
      {data?.services.length === 0 && <p className="text-sm text-ink/60" data-testid="extras-empty">No extras are set up in eRes for this hotel yet. Add them in eRes and they will appear here.</p>}
      <div className="space-y-5">
        {data?.services.map((s) => {
          const v = values[s.id] || {};
          const w = owner[s.id] || {};
          return (
            <div key={s.id} className="grid gap-4 rounded-xl border border-ink/10 p-4 md:grid-cols-2" data-testid={`admin-extra-${s.id}`}>
              <p className="text-sm font-medium text-ink md:col-span-2">{s.name} <span className="font-mono text-xs text-ink/50">{money(s.price, data.currency)}</span></p>
              <div className="md:col-span-2"><ImageField label="Photo" value={v.image || ""} placeholder={w.image || s.image} placeholderLabel={w.image ? "Using the verified owner's photo" : undefined} onChange={(x) => set(s.id, { image: x })} testid={`extra-${s.id}-image`} /></div>
              <div className="md:col-span-2"><TextField multiline label="Short description" value={v.description || ""} placeholder={w.description || s.description} onChange={(x) => set(s.id, { description: x })} testid={`extra-${s.id}-description`} /></div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};
